import { Box, Typography } from "@mui/material";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import QrCodeIcon from "@mui/icons-material/QrCode";
import { renderModal } from "../handlers";
import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import FormEnviarPorEmail from "./FormEnviarPorEmail";
import InformacionAdicionalFotoMulta from "./InformacionAdicionalFotoMulta";

const Recibo = ({ recibo, setRecibo }) => {
  const navigate = useNavigate();
  const [qrModalIsOpen, setQrModalIsOpen] = useState(false);
  const [sendEmailModalIsOpen, setSendEmailModalIsOpen] = useState(false);

  if (recibo && recibo.pago) {
    return (
      <div>
        <Button
          className="btn btn-primary mb-3"
          onClick={() => {
            setRecibo(null);
            navigate('/pagar');
          }}
        >
          Volver
        </Button>
        <p className="mb-0 alert alert-info fw-bold">El acta consultada ya fue pagada</p>
      </div>
    );
  }

  if (recibo && recibo.is_espontaneo/*  && recibo.is_espontaneo === 1 */) {
    return (
      <div
        className={
          'bg-white rounded  '/*  +
          (recibo.qr && recibo.qrLink
            ? ' offset-md-2 offset-lg-1 col-sm-8 col-sm-10 col-md-8 col-lg-10 offset-sm-1'
            : '') */
        }
      >
        {recibo.pago && (
          <div className="alert alert-info mb-0 fw-bold">
            <p className="mb-0">El recibo ya fue pagado</p>
          </div>
        )}
        {recibo?.informacion_adicional ? (
          <InformacionAdicionalFotoMulta informacionAdicional={recibo?.informacion_adicional} />
        ) : null}
        <div className=" d-flex flex-column justify-content-center align-items-center">
          {recibo.qrLink ? (
            <>
              <div className='my-4'>
                <QRCodeSVG
                  size="175"
                  onClick={() => {
                    setQrModalIsOpen(false);
                  }}
                  value={recibo.qrLink}
                />
              </div>
              <p className="mb-0 fw-bold text-center">
                Escanea el QR o haga click{' '}
                <a target="_blank" rel="noopener noreferrer" href={recibo.qrLink}>
                  aquí
                </a>
                , para continuar con el pago
              </p>
            </>
          ) : (
            <>
              {' '}
              <p className="mb-2 ">El QR de su recibo no se encuentra disponible.</p>
              {recibo.numero_recibo && (
                <p className="mb-0 fw-semibold">
                  Haga click{' '}
                  <a
                    href={
                      'https://sigemi.muninqn.gov.ar/apex/f?p=304:QRR:0:::SESSION:P7087_NRO_RECIBO:' +
                      recibo.numero_recibo
                    }
                    target="_blank"
                    className="fw-semibold"
                    rel="noopener noreferrer"
                  >
                    aquí
                  </a>
                  , para continuar con el pago
                </p>
              )}
              {/* <h5 className="text-center fw-semibold">Por favor, intente nuevamente más tarde.</h5> */}
            </>
          )}
        </div>
        <div className="mt-3 text-center">
          <a
            href="https://weblogin.neuquencapital.gov.ar/#/login"
            target="_blank"
            className="fw-bold text-center"
            rel="noopener noreferrer"
          >
            Si querés ver el Acta y el video de la infracción, create un usuario en Mi Muni Digital
          </a>
        </div>
      </div>
    );
  }

  return (
    <Box>
      {recibo.pago && (
        <div className='d-block d-md-none alert alert-info fw-bold'>
          <p className='mb-0'>El recibo ya fue pagado</p>
        </div>
      )}
      {recibo?.informacion_adicional ? (
        <InformacionAdicionalFotoMulta informacionAdicional={recibo?.informacion_adicional} />
      ) : null}
      <Box className='row mt-3'>
        <Box className='col-md-8'>
          <iframe src={recibo.pdf?.base64} height='650px' width='100%' id='pdf' title={"PDF Recibo"}></iframe>
        </Box>
        <Box className='col-md-4'>
          <Box className='card text-center'>
            <Box className='card-header text-center' style={{ backgroundColor: "#1134C9" }}>
              <span className='card-title fw-bold text-white'>RECIBO</span>
            </Box>
            <Box
              className='card-body text-center'
              style={{ border: "1px solid #1134C9", borderRadius: "0 0 0.375rem 0.375rem" }}
            >
              {recibo.pago ? (
                <div className='alert alert-info fw-bold'>
                  <p className='mb-0'>El recibo ya fue pagado</p>
                </div>
              ) : (
                <Typography className='mb-4'>Se generó el recibo de su acta</Typography>
              )}
              <Box className='btn-wrapper d-flex flex-column'>
                {recibo.qrLink ? (
                  <Button className='mb-2 w-100 border-none' onClick={() => setQrModalIsOpen(true)}>
                    <QrCodeIcon /> Pagar Online
                  </Button>
                ) : null}
                {/* <Button className="mb-2" onClick={() => setSendEmailModalIsOpen(true)}> <EmailIcon /> Enviar por email</Button> */}
                <Button className='btn btn-primary' onClick={() => {
                    setRecibo(null)
                    navigate('/pagar')
                  }}>
                  Volver
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
        {renderModal(
          qrModalIsOpen,
          setQrModalIsOpen,
          "Pagar Online",
          <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
            <Box>
              <QRCodeSVG
                size='175'
                onClick={() => {
                  setQrModalIsOpen(false);
                }}
                value={recibo.qrLink}
              />
            </Box>
            <Typography className='mt-3 fw-bold text-center'>
              Escanea el QR o haga click {' '}
              <a target='_blank' rel='noopener noreferrer' href={recibo.qrLink}>
                aquí
              </a>, para continuar con el pago
            </Typography>
          </Box>
        )}

        {/* {renderModal(sendEmailModalIsOpen, setSendEmailModalIsOpen, 'Enviar por Email', <FormEnviarPorEmail acta={acta} />)} */}
      </Box>
    </Box>
  );
};

export default Recibo;
